import { useEffect, useState } from "react";
import styled, { css } from "styled-components";
import { getLocale } from "react-i18nify";
import moment from "moment";

import font from "src/styles/font";
import device from "src/styles/device";
import { checkNotEmpty } from "src/common";
import useModal from "src/hooks/useModal";
import useDeviceSize from "src/hooks/useDeviceSize";

import { getAllCustomer } from "src/api/quotationDraft";
// import {
//   // getAddressThai,
//   getProvinceThai,
//   getAmphoeThai,
//   getTambonThai,
//   getZipcodeThai,
// } from "src/api/address";

import {
  TextField,
  Grid,
  Autocomplete,
  createFilterOptions,
  FormControl,
  FormLabel,
  FormControlLabel,
  RadioGroup,
  Radio,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  Box,
} from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import Button from "src/components/core/Button";

import AddIcon from "@mui/icons-material/Add";

import DocumentGrid from "./DocumentGrid";
import ModalAddition from "./AdditionModal";

import AddressAutocomplete from "src/components/core/AddressAutocomplete";

const CustomerType = styled.div`
  width: calc(100% + 48px);
  margin-left: -24px;
  padding: 0 24px 24px;
  border-bottom: 10px var(--darkwhite-color) solid;

  @media ${device.tabletL} {
    width: calc(100% + 80px);
    margin-left: -40px;
    padding: 0 40px 16px;
  }
  @media ${device.mobileL} {
    width: calc(100% + 48px);
    margin-left: -24px;
    padding: 0 24px 16px;
  }
`;

const SpanLabel = styled.div`
  font-size: ${font.size.lg};
  color: var(--secondary-color);
  font-weight: 400;

  span {
    font-size: ${font.size.lg};
    font-weight: 400;
    color: var(--primary-color);
  }
`;

const WrapperTextfield = styled.div`
  /* width: ${({ half }) => (half ? "48.5%" : "100%")}; */
  width: 100%;

  @media ${device.tabletL} {
    max-width: ${({ half }) => (half ? "250px" : "530px")};

    ${({ left, right }) =>
      left
        ? css`
            margin-left: auto;
          `
        : right
          ? css`
              margin-right: auto;
            `
          : css`
              margin: 0 auto;
            `}
  }

  .TextField-without-border-radius fieldset {
    border-radius: 24px;
    // text-align: center;
    // background: #fff;
  }
  .TextField-without-border-radius-amount fieldset {
    border-radius: 24px;
    width: 100%;
    text-align: center;
    background: #fff;
  }
  .MuiAutocomplete-root {
    /* margin: ${({ item }) => (item ? "0" : "24px 0")}; */
    margin: 0;
  }
  .MuiOutlinedInput-input {
    background: #fff;
    /* border-radius: 24px; */
    padding: 16px;
  }
  .MuiInputBase-root-MuiOutlinedInput-root {
    border-radius: 24px;
    background: #fff;
  }
  .MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root {
    border-radius: 24px;
  }

  .MuiTextField-root {
    border-radius: 24px;
  }
  .MuiOutlinedInput-root {
    border-radius: 24px;
  }
  .MuiAutocomplete-root .MuiOutlinedInput-root .MuiAutocomplete-input {
    padding: 7.5px 0;
  }
`;

const Step1 = ({
  customerType,
  onChangeCustomerType,
  formErrors,
  formData,
  onChange,
  // onAppendElement,
  // onAppendData,
  // onRemoveElement,
  dataProductList,
  dataServiceType,
  onAppendProduct,
  onAppendProductData,
  onRemoveProduct,
  onAppendService,
  onAppendServiceData,
  onRemoveService,
  onAppendOther,
  onAppendOtherData,
  onRemoveOther,
}) => {
  const [deviceWidth] = useDeviceSize();
  const { getModalState, open, close } = useModal();

  const [dataCustomerList, setDataCustomerList] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);

  const filterOptions = createFilterOptions({
    matchFrom: "any",
    limit: 100,
  });

  const fetchCustomer = async () => {
    await getAllCustomer().then(async ({ data }) => {
      if (data?.length > 0) {
        setDataCustomerList(data);
      }
    });
  };

  useEffect(() => {
    fetchCustomer();
  }, []);

  const handleSelectedOldCustomer = (data) => {
    // console.log('--- selected customer ----', data);
    setSelectedCustomer(data);
    onChange(null, `old_customer`, data);
  };

  return (
    <>
      <Grid
        container
        sx={{
          m: 0,
          mb: { md: 3 },
          px: { xs: 3, sm: 5, md: 3 },
          py: { xs: 3, md: 5 },
          width: "100%",
          borderRadius: { md: "24px" },
          background: "var(--white-color)",
          boxShadow: {
            md: "0px 0px 10px 0px rgba(0, 0, 0, 0.10)",
          },
          borderBottom: {
            xs: "10px var(--darkwhite-color) solid",
            md: "none",
          },
        }}
      >
        {/* Customer type */}
        <Grid item xs={12} sx={{ mb: { xs: 3, md: 4 } }}>
          <CustomerType>
            <FormControl sx={{ width: "100%" }}>
              <FormLabel
                id="customer-type-radio-group-label"
                sx={{
                  fontSize: font.size.lg,
                  color: "var(--secondary-color)",
                  mb: 2,
                  span: {
                    color: "var(--primary-color)",
                    fontSize: font.size.lg,
                  },
                  "&.Mui-focused": {
                    color: "var(--secondary-color)",
                  },
                }}
              >
                {getLocale() === "th" ? "ประเภทลูกค้า" : "Customer Type"}
                <span>*</span>
              </FormLabel>

              <RadioGroup
                row
                aria-labelledby="customer-type-radio-group-label"
                name="customer-type-radio-group"
                sx={{
                  width: "100%",
                  maxWidth: {
                    xs: 530,
                    md: "unset",
                  },
                  mx: {
                    xs: "auto",
                    md: 0,
                  },
                  px: {
                    xs: 0,
                    md: 4,
                  },
                }}
                value={customerType}
                onChange={(e) => onChangeCustomerType(e.target.value)}
              >
                <FormControlLabel
                  value="business"
                  sx={{
                    flex: "0 0 50%",
                    width: "50%",
                    m: 0,
                    "&.MuiRadio-root": {
                      width: "auto",
                    },
                  }}
                  control={
                    <Radio
                      sx={{
                        fontSize: font.size.md,
                        color: "var(--primary-color)",
                        "&.Mui-checked": {
                          color: "var(--primary-color)",
                        },
                        "& .MuiSvgIcon-root": {
                          fontSize: 22,
                        },
                      }}
                    />
                  }
                  label={getLocale() === "th" ? "บริษัท" : "Company"}
                />

                <FormControlLabel
                  value="customer"
                  sx={{
                    flex: "0 0 50%",
                    width: "50%",
                    m: 0,
                    "&.MuiRadio-root": {
                      width: "auto",
                    },
                  }}
                  control={
                    <Radio
                      sx={{
                        fontSize: font.size.md,
                        color: "var(--primary-color)",
                        "&.Mui-checked": {
                          color: "var(--primary-color)",
                        },
                        "& .MuiSvgIcon-root": {
                          fontSize: 22,
                        },
                      }}
                    />
                  }
                  label={getLocale() === "th" ? "ลูกค้าทั่วไป" : "Customer"}
                />
              </RadioGroup>
            </FormControl>
          </CustomerType>
        </Grid>

        {/* Old-customer select */}
        <Grid item xs={12}>
          <SpanLabel>
            เพิ่มข้อมูลจากลูกค้าเก่า{" "}
            <span style={{ color: "var(--darkgrey-color)" }}>(หากมี)</span>
          </SpanLabel>

          {/* ลูกค้าเก่าแล้วเคยออก quotation-draft แล้ว 
            ? // * เอาที่อยู่ไปใส่ 
            : //! ไม่ต้องเอาข้อมูลที่อยู่ไปใส่ */}

          <Grid
            container
            spacing={3}
            rowSpacing={3}
            columnSpacing={4}
            sx={{
              mt: 0,
              mb: 3,
              ".MuiOutlinedInput-root": {
                borderRadius: "24px",
              },
              "label[data-shrink=false]": {
                opacity: 0.65,
              },
            }}
          >
            <Grid item xs={12} md={6}>
              <WrapperTextfield>
                <Autocomplete
                  id="search-customer-similars"
                  isOptionEqualToValue={(option, value) =>
                    option.filter === value.filter
                  }
                  renderOption={(props, option) => (
                    <li
                      {...props}
                      style={{
                        padding: "8px 24px",
                        ":first-child": {
                          paddingTop: "24px",
                        },
                        ":last-child": {
                          paddingBottom: "24px",
                        },
                      }}
                    >
                      {`${
                        checkNotEmpty(option?.contact?.full_name) ||
                        option?.contact?.full_name !== ""
                          ? option?.contact?.full_name
                          : option?.contact?.company_name !== ""
                            ? option?.contact?.company_name
                            : option?.email
                      } ${
                        option?.project !== "" ? `(${option?.project})` : ``
                      }`}
                    </li>
                  )}
                  options={dataCustomerList}
                  value={selectedCustomer}
                  onChange={(event, newValue) => {
                    handleSelectedOldCustomer(newValue);
                  }}
                  getOptionLabel={(option) => {
                    return `${
                      checkNotEmpty(option?.contact?.full_name) ||
                      option?.contact?.full_name !== ""
                        ? option?.contact?.full_name
                        : option?.contact?.company_name !== ""
                          ? option?.contact?.company_name
                          : option?.email
                    } ${option?.project !== "" ? `(${option?.project})` : ``}`;
                  }}
                  filterOptions={filterOptions}
                  sx={{
                    my: 2,
                    width: "100%",
                    background: "#fff",
                    ".MuiOutlinedInput-root": {
                      paddingLeft: "16px",
                    },
                    ".MuiAutocomplete-option": {
                      p: 3,
                    },
                    // "label[data-shrink=false]": {
                    //   opacity: 0.65,
                    // },
                  }}
                  renderInput={(params) => (
                    <TextField
                      className="TextField-without-border-radius"
                      {...params}
                      label="ค้นหาจากชื่อ/ชื่อโครงการ"
                    />
                  )}
                />
              </WrapperTextfield>
            </Grid>
          </Grid>
        </Grid>

        {/* Project */}
        <Grid item xs={12}>
          <SpanLabel>
            ข้อมูลโครงการ<span>*</span>
          </SpanLabel>

          <Grid
            container
            spacing={3}
            rowSpacing={3}
            columnSpacing={4}
            sx={{
              mt: 0,
              mb: 3,
              ".MuiOutlinedInput-root": {
                borderRadius: "24px",
              },
              // "label[data-shrink=false]": {
              //   opacity: 0.65,
              // },
              ".MuiFormHelperText-root": {
                position: "absolute",
                bottom: "-20px",
              },
            }}
          >
            <Grid item xs={12} md={6}>
              <WrapperTextfield>
                <TextField
                  label="Project Name"
                  variant="outlined"
                  fullWidth
                  required
                  value={formData?.project}
                  onChange={(e) => onChange(e, `project`)}
                  error={!!formErrors[`project`]}
                  helperText={
                    !!formErrors[`project`] ? "Please enter project name" : ""
                  }
                />
              </WrapperTextfield>
            </Grid>
          </Grid>
        </Grid>

        {/* Customer detail */}
        <Grid item xs={12}>
          <SpanLabel>
            ข้อมูลติดต่อ<span>*</span>
          </SpanLabel>

          <Grid
            container
            spacing={3}
            rowSpacing={3}
            columnSpacing={4}
            sx={{
              mt: 0,
              mb: 3,
              ".MuiOutlinedInput-root": {
                borderRadius: "24px",
              },
              // "label[data-shrink=false]": {
              //   opacity: 0.65,
              // },
              ".MuiFormHelperText-root": {
                position: "absolute",
                bottom: "-20px",
              },
            }}
          >
            <Grid item xs={12} md={6}>
              <WrapperTextfield>
                <TextField
                  label="Full Name"
                  variant="outlined"
                  fullWidth
                  required
                  value={formData?.contact?.full_name}
                  onChange={(e) => onChange(e, `contact.full_name`)}
                  error={!!formErrors[`contact.full_name`]}
                  helperText={
                    !!formErrors[`contact.full_name`]
                      ? "Please enter full name"
                      : ""
                  }
                />
              </WrapperTextfield>
            </Grid>

            {customerType === "business" && (
              <>
                <Grid item xs={12} md={6}>
                  <WrapperTextfield>
                    <TextField
                      label="Company Name"
                      variant="outlined"
                      fullWidth
                      required
                      value={formData?.company_name}
                      onChange={(e) => onChange(e, `company_name`)}
                      error={!!formErrors[`company_name`]}
                      helperText={
                        !!formErrors[`company_name`]
                          ? "Please enter company name"
                          : ""
                      }
                    />
                  </WrapperTextfield>
                </Grid>

                <Grid item xs={12} md={6}>
                  <WrapperTextfield>
                    <TextField
                      label="Branch"
                      variant="outlined"
                      fullWidth
                      required
                      value={formData?.branch}
                      onChange={(e) => onChange(e, `branch`)}
                      error={!!formErrors[`branch`]}
                      helperText={
                        formErrors[`branch`]?.message
                          ? formErrors[`branch`]?.message
                          : ""
                      }
                    />
                  </WrapperTextfield>
                </Grid>
              </>
            )}

            <Grid item xs={12} md={6}>
              <WrapperTextfield>
                <TextField
                  label="ID Tax"
                  variant="outlined"
                  fullWidth
                  required={customerType === "business"}
                  value={formData?.contact?.tax_id}
                  onChange={(e) => onChange(e, `contact.tax_id`)}
                  error={!!formErrors[`contact.tax_id`]}
                  helperText={
                    !!formErrors[`contact.tax_id`] ? "Please enter ID Tax" : ""
                  }
                />
              </WrapperTextfield>
            </Grid>

            <Grid item xs={12} md={6}>
              <WrapperTextfield>
                <TextField
                  label="E-mail"
                  variant="outlined"
                  fullWidth
                  value={formData?.contact?.email}
                  onChange={(e) => onChange(e, `contact.email`)}
                  error={!!formErrors[`contact.email`]}
                  helperText={
                    formErrors[`contact.email`]?.message
                      ? formErrors[`contact.email`]?.message
                      : ""
                  }
                />
              </WrapperTextfield>
            </Grid>

            <Grid item xs={12} md={6}>
              <WrapperTextfield>
                <TextField
                  label="Phone Number"
                  variant="outlined"
                  fullWidth
                  required
                  value={formData?.contact?.phone_number}
                  onChange={(e) => onChange(e, `contact.phone_number`)}
                  error={!!formErrors[`contact.phone_number`]}
                  helperText={
                    formErrors[`contact.phone_number`]?.message
                      ? formErrors[`contact.phone_number`]?.message
                      : ""
                  }
                />
              </WrapperTextfield>
            </Grid>

            <Grid item xs={12} md={6}>
              <WrapperTextfield>
                <TextField
                  label="Tel."
                  variant="outlined"
                  fullWidth
                  value={formData?.contact?.tel}
                  onChange={(e) => onChange(e, `contact.tel`)}
                  error={!!formErrors[`contact.tel`]}
                  helperText={
                    !!formErrors[`contact.tel`] ? "Please enter tel." : ""
                  }
                />
              </WrapperTextfield>
            </Grid>

            <Grid item xs={12} md={6}>
              <WrapperTextfield>
                <TextField
                  label="Fax"
                  variant="outlined"
                  fullWidth
                  value={formData?.contact?.fax}
                  onChange={(e) => onChange(e, `contact.fax`)}
                  error={!!formErrors[`contact.fax`]}
                  helperText={
                    !!formErrors[`contact.fax`] ? "Please enter fax" : ""
                  }
                />
              </WrapperTextfield>
            </Grid>
          </Grid>
        </Grid>

        {/* Address */}
        <Grid item xs={12}>
          <SpanLabel>
            ที่อยู่<span>*</span>
          </SpanLabel>

          <Grid
            container
            spacing={3}
            rowSpacing={3}
            columnSpacing={4}
            sx={{
              mt: 0,
              mb: 3,
              ".MuiOutlinedInput-root": {
                borderRadius: "24px",
              },
              // "label[data-shrink=false]": {
              //   opacity: 0.65,
              // },
              ".MuiFormHelperText-root": {
                position: "absolute",
                bottom: "-20px",
              },
            }}
          >
            <Grid item xs={12} md={6}>
              <WrapperTextfield>
                <AddressAutocomplete
                  value={
                    checkNotEmpty(formData?.contact?.province)
                      ? {
                          province: formData?.contact?.province || "",
                          district: formData?.contact?.district || "",
                          subdistrict: formData?.contact?.sub_district || "", // Little bit different field name from API
                          zipcode: formData?.contact?.zipcode || "",
                        }
                      : null
                  }
                  onChange={(value) => {
                    if (value) {
                      onChange(null, `contact.province`, value.province);
                      onChange(null, `contact.district`, value.district);
                      onChange(null, `contact.sub_district`, value.subdistrict); // Little bit different field name from API
                      onChange(null, `contact.zipcode`, value.zipcode);
                    } else {
                      onChange(null, `contact.province`, "");
                      onChange(null, `contact.district`, "");
                      onChange(null, `contact.sub_district`, ""); // Little bit different field name from API
                      onChange(null, `contact.zipcode`, "");
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      className="TextField-without-border-radius"
                      {...params}
                      label="Sub-District/District/Province/Zipcode"
                      variant="outlined"
                      fullWidth
                      required
                      error={
                        !!formErrors[`contact.sub_district`] ||
                        !!formErrors[`contact.district`] ||
                        !!formErrors[`contact.province`] ||
                        !!formErrors[`contact.zipcode`]
                      }
                      helperText={
                        (!!formErrors[`contact.sub_district`] ||
                          !!formErrors[`contact.district`] ||
                          !!formErrors[`contact.province`] ||
                          !!formErrors[`contact.zipcode`]) &&
                        "Please select address"
                      }
                    />
                  )}
                />
              </WrapperTextfield>
            </Grid>

            <Grid item xs={12} md={6}>
              <WrapperTextfield>
                <TextField
                  label="House No/Village/Building/Alley"
                  placeholder="House No/Village/Building/Alley"
                  variant="outlined"
                  fullWidth
                  value={formData?.contact?.address}
                  onChange={(e) => onChange(e, `contact.address`)}
                  error={!!formErrors[`contact.address`]}
                  helperText={
                    !!formErrors[`contact.address`]
                      ? "Please enter address"
                      : ""
                  }
                />
              </WrapperTextfield>
            </Grid>
          </Grid>
        </Grid>

        {/* Document Detail */}
        <Grid item xs={12}>
          <SpanLabel>
            ข้อมูลเอกสาร<span>*</span>
          </SpanLabel>

          <Grid
            container
            spacing={3}
            rowSpacing={3}
            columnSpacing={{ xs: 3, md: 4 }}
            sx={{
              mt: 0,
              // mb: 3,
              ".MuiOutlinedInput-root": {
                borderRadius: "24px",
              },
              // "label[data-shrink=false]": {
              //   opacity: 0.65,
              // },
              ".MuiFormHelperText-root": {
                position: "absolute",
                bottom: "-20px",
              },
            }}
          >
            <Grid item xs={12} md={6}>
              <WrapperTextfield>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="Date"
                    inputFormat="DD/MM/YYYY"
                    value={formData?.document_date}
                    onChange={(newValue) =>
                      onChange(null, `document_date`, newValue)
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        sx={{
                          // my: 2,
                          width: "100%",
                          background: "#fff",
                          ".MuiOutlinedInput-root": {
                            paddingRight: "18px",
                          },
                        }}
                        error={!!formErrors[`document_date`]}
                        helperText={
                          !!formErrors[`document_date`]
                            ? "Please select document date"
                            : ""
                        }
                      />
                    )}
                  />
                </LocalizationProvider>
              </WrapperTextfield>
            </Grid>

            <Grid item xs={6} md={3}>
              <WrapperTextfield half left>
                <FormControl fullWidth error={!!formErrors[`aging`]}>
                  <InputLabel id="aging-select-label">Aging</InputLabel>
                  <Select
                    labelId="aging-select-label"
                    id="aging-select"
                    value={formData?.aging === 0 ? "" : formData?.aging}
                    label="Aging"
                    onChange={(e) => onChange(e, `aging`)}
                  >
                    <MenuItem value=""></MenuItem>
                    <MenuItem value={1}>1</MenuItem>
                    <MenuItem value={2}>2</MenuItem>
                    <MenuItem value={3}>3</MenuItem>
                    <MenuItem value={4}>4</MenuItem>
                    <MenuItem value={5}>5</MenuItem>
                    <MenuItem value={6}>6</MenuItem>
                    <MenuItem value={7}>7</MenuItem>
                  </Select>
                  {!!formErrors[`aging`] && (
                    <FormHelperText sx={{ width: "max-content" }}>
                      Please select aging date
                    </FormHelperText>
                  )}
                </FormControl>
              </WrapperTextfield>
            </Grid>

            <Grid item xs={6}>
              <WrapperTextfield half right>
                <TextField
                  label="Expiry date"
                  variant="outlined"
                  fullWidth
                  disabled
                  value={
                    formData.expire_date !== ""
                      ? moment(formData.expire_date).format("DD/MM/YYYY")
                      : ""
                  }
                />
              </WrapperTextfield>
            </Grid>

            <Grid item xs={12} md={6}>
              <WrapperTextfield>
                <TextField
                  label="Sale Code"
                  variant="outlined"
                  fullWidth
                  value={formData?.sale_code}
                  onChange={(e) => onChange(e, `sale_code`)}
                />
              </WrapperTextfield>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {/* Product table */}
      <DocumentGrid
        formData={formData}
        formErrors={formErrors}
        onChange={onChange}
        dataProductList={dataProductList}
        dataServiceType={dataServiceType}
        // onAppendElement={onAppendElement}
        // onAppendData={onAppendData}
        // onRemoveElement={onRemoveElement}
        onAppendProduct={onAppendProduct}
        onAppendProductData={onAppendProductData}
        onRemoveProduct={onRemoveProduct}
        onAppendService={onAppendService}
        onAppendServiceData={onAppendServiceData}
        onRemoveService={onRemoveService}
        onAppendOther={onAppendOther}
        onAppendOtherData={onAppendOtherData}
        onRemoveOther={onRemoveOther}
      />

      {/* Remark */}
      <Grid
        container
        sx={{
          mt: {
            xs: 4,
            sm: 3,
            md: 2,
          },
          px: {
            xs: 3,
            sm: 5,
            md: 0,
          },
          fontSize: font.size.md,
          ".MuiAutocomplete-root": {
            margin: 0,
          },
          ".MuiTextField-root": {
            borderRadius: "24px",
          },
          ".MuiOutlinedInput-root": {
            borderRadius: "24px",
          },
          ".MuiOutlinedInput-input": {
            py: "10px",
            textAlign: "center",
          },
          ".MuiInputBase-inputMultiline": {
            p: 0,
            textAlign: "left",
          },
          ".MuiAutocomplete-root .MuiOutlinedInput-root .MuiAutocomplete-input":
            {
              px: 0,
            },
        }}
      >
        <Grid
          item
          xs={12}
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: {
              xs: "center",
              md: "flex-start",
            },
            justifyContent: "center",
          }}
        >
          {formData?.remark === "" ? (
            <Button
              variant={deviceWidth > 835 ? "text" : "outlined"}
              sx={{
                px: 3,
                py: {
                  xs: 1.5,
                  md: 1,
                },
                borderRadius: 3,
                width: {
                  xs: "100%",
                  md: "max-content",
                },
                maxWidth: {
                  xs: 350,
                  md: "unset",
                },
                "&.MuiButton-outlined": {
                  border: "1px var(--primary-color) solid",
                },
              }}
              startIcon={<AddIcon />}
              onClick={() => {
                open(`remark.add-remark-modal`);
              }}
            >
              {getLocale() === "th" ? `เพิ่มหมายเหตุ` : `Add Remark`}
            </Button>
          ) : deviceWidth > 835 ? (
            <Button
              variant={deviceWidth > 835 ? "text" : "outlined"}
              sx={{
                px: 3,
                py: {
                  xs: 1.5,
                  md: 1,
                },
                borderRadius: 3,
                width: {
                  xs: "100%",
                  md: "max-content",
                },
                maxWidth: {
                  xs: 350,
                  md: "unset",
                },
                "&.MuiButton-outlined": {
                  border: "1px var(--primary-color) solid",
                },
              }}
              onClick={() => {
                open(`remark.add-remark-modal`, true);
              }}
              disabled={formData?.remark?.length >= 400}
            >
              {getLocale() === "th" ? `แนะนำหมายเหตุ` : `Suggest Remark`}
            </Button>
          ) : null}
        </Grid>

        {formData?.remark !== "" ? (
          <Grid
            item
            xs={12}
            sx={{
              mt: {
                xs: 0,
                md: 2,
              },
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: {
                xs: "center",
                md: "flex-start",
              },
              justifyContent: "center",
            }}
          >
            <TextField
              variant="outlined"
              multiline
              fullWidth
              sx={{
                ".MuiOutlinedInput-root": {
                  p: 2,
                },
                ".MuiOutlinedInput-input": {
                  py: 0,
                  lineHeight: 1.8,
                  textAlign: "left",
                },
              }}
              inputProps={{
                readOnly: deviceWidth > 835 ? false : true,
                maxLength: 400,
              }}
              value={formData?.remark}
              onChange={(e) => {
                onChange(e, `remark`);
              }}
              onClick={() => {
                if (deviceWidth <= 835) {
                  open(`remark.add-remark-modal`, true);
                }
              }}
              helperText={
                <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                  {formData?.remark?.length}/400
                </Box>
              }
              error={formData?.remark?.length > 400}
            />
          </Grid>
        ) : null}
      </Grid>

      {/* Add remark modal */}
      <ModalAddition
        type="remark"
        descData={formData?.remark}
        docType="remark"
        isOpen={getModalState(`remark.add-remark-modal`)?.isOpen}
        isEdit={getModalState(`remark.add-remark-modal`)?.isEdit}
        onClose={() => close(`remark.add-remark-modal`)}
        onSubmit={(val) => {
          onChange(null, `remark`, val);
          close(`remark.add-remark-modal`);
        }}
      />
    </>
  );
};

export default Step1;
